/**
 * Calcula el siguiente número de comprobante a partir de los existentes.
 * Soporta: "1", "005", "0001-00000012"
 */
export function getNextInvoiceNumber(existing = []) {
  const numbers = (Array.isArray(existing) ? existing : [])
    .map((item) => (typeof item === 'object' && item != null ? item.numero : item))
    .filter((n) => n != null && String(n).trim() !== '');

  if (!numbers.length) return '1';

  let bestAfip = null;
  let bestPlain = null;

  for (const raw of numbers) {
    const s = String(raw).trim();
    const afip = s.match(/^(\d{4}-)(\d+)$/);
    if (afip) {
      const n = parseInt(afip[2], 10);
      if (!Number.isNaN(n) && (!bestAfip || n > bestAfip.n)) {
        bestAfip = { prefix: afip[1], n, pad: afip[2].length };
      }
      continue;
    }
    if (/^\d+$/.test(s)) {
      const n = parseInt(s, 10);
      if (!Number.isNaN(n) && (!bestPlain || n > bestPlain.n)) {
        bestPlain = { n, pad: s.length };
      }
    }
  }

  if (bestAfip) {
    const next = bestAfip.n + 1;
    return `${bestAfip.prefix}${String(next).padStart(bestAfip.pad, '0')}`;
  }
  if (bestPlain) {
    const next = bestPlain.n + 1;
    return String(next).padStart(bestPlain.pad, '0');
  }

  return String(numbers.length + 1);
}
